import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { BidderDetailModel } from "../../models/BidderDetailModel";
import BidderDetailService from "../../services/BidderDetailService";
import BidderDetailSlice from "../slices/BidderDetailSlice";
import { RootState } from "../store";

export const Actions = BidderDetailSlice.actions;
export const fetchProjectBidderDetails = (
  projectId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: BidderDetailModel[] =
      await BidderDetailService.getProjectBidderDetails(projectId);
    dispatch(Actions.setBidderDetails(response));
  };
};
